function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E11F26",
  fillRule: "evenodd",
  d: "M2 2v20h20V2zm18.746 18.752H3.248V3.249h17.498zm-6.135-5.038a.57.57 0 0 1-.491.366h-.246a.57.57 0 0 1-.365-.731L15.96 8a.58.58 0 1 1 1.103.366zm-7.714.366a.57.57 0 0 0 .492-.366l2.445-7.348a.537.537 0 0 0-.365-.732.537.537 0 0 0-.732.366l-2.451 7.349a.57.57 0 0 0 .365.731zm3.554 0h-.245a.57.57 0 0 1-.372-.731L12.286 8a.581.581 0 0 1 1.103.366l-2.452 7.348c0 .12-.12.366-.486.366",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-what3word.svg";
export { SvgComponent as ReactComponent };